import { FC } from 'react';
import { Icon } from 'learning-panel-components';
import { useNavigate } from 'react-router-dom';
import { translate } from 'translations';
import styles from './topBar.module.scss';

const QuizTopBar: FC<QuizTopBarProps> = (props: QuizTopBarProps) => {
    const { name, mistakesStatuses, setShowQuitPopup } = props;
    const navigate = useNavigate();

    const generateStatus = (status: boolean) => (
        <Icon name={status ? 'mistake' : 'maybeMistake'} key={status ? 'mistake' : 'maybeMistake'} />
    );
    const statusesArray = Object.entries(mistakesStatuses).map(([key, value]) => ({
        key: parseInt(key, 10),
        value
    }));

    return (
        <div className={styles['quiz-top-wrapper']}>
            <div className={styles.left}>
                <img
                    src={`${process.env.PUBLIC_URL}/images/cxSmallLogo.svg`}
                    className={styles.logo}
                    alt="Codebashing Logo"
                />
                <div className={styles['cx-uni-top']}>
                    <div className={styles['logo-divider']} />
                    <img
                        src={`${process.env.PUBLIC_URL}/images/cxUniversityLogo.svg`}
                        className={styles['cx-uni-logo']}
                        alt="CX University Logo"
                    />
                </div>
                <div className={styles.info}>
                    <div className={styles['back-content']} onClick={(): void => navigate(-1)}>
                        <Icon name="back" className={styles['back-icon']} />
                        <div>{translate('Back')}</div>
                    </div>
                    <div className={styles.divider}></div>
                    <div className={styles['end-test']} onClick={() => setShowQuitPopup(true)}>
                        {translate('CertificateTest')}
                    </div>
                    <div className={styles.divider}></div>
                    <div className={styles['quiz-name']}>{name}</div>
                </div>
            </div>

            <div className={styles['mistakes-wrapper']}>
                <div className={styles['mistakes-text-wrapper']}>
                    <div className={styles.mistakes}>{translate('MistakesAllowed')}</div>
                    <div className={styles['questions-wrapper']}>
                        <div>
                            <span className={styles['red-text']}>
                                {statusesArray.filter(({ value }) => value).length}/
                            </span>
                            <span className={styles['black-text']}>{Object.keys(mistakesStatuses).length}</span>
                        </div>
                    </div>
                    {statusesArray.map(({ key, value }) => (
                        <div key={key}>{generateStatus(value)}</div>
                    ))}
                </div>
            </div>
        </div>
    );
};

interface QuizTopBarProps {
    name: string;
    mistakesStatuses: Record<number, boolean>;
    setShowQuitPopup: Function;
}

export default QuizTopBar;
